var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadExcelTemplateGreenIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 21.5 19.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "download (3)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2115"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#69e384",
    d: "M20.884 9.714a.613.613 0 0 0-.616.616v5.6a2.764 2.764 0 0 1-2.761 2.761H3.993a2.764 2.764 0 0 1-2.761-2.761v-5.695a.616.616 0 1 0-1.232 0v5.695a4 4 0 0 0 3.993 3.993h13.515a4 4 0 0 0 3.993-3.993v-5.6a.616.616 0 0 0-.617-.616z",
    "data-name": "Path 424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69e384",
    d: "M10.317 15.035a.62.62 0 0 0 .434.183.6.6 0 0 0 .433-.183l3.915-3.915a.617.617 0 0 0-.872-.872l-2.861 2.866V.614a.616.616 0 0 0-1.232 0v12.5L7.269 10.25a.617.617 0 0 0-.872.872z",
    "data-name": "Path 425"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExcelTemplateGreenIcon);
export default __webpack_public_path__ + "static/media/DownloadExcelTemplateGreenIcon.595c5145b46188ccf5d57de1fd20d9b8.svg";
export { ForwardRef as ReactComponent };